// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].use[1]!../../../../node_modules/@jetbrains/ring-ui/components/global/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.backgroundColor__db0 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--ring-navigation-background-color);
  z-index: -2;
}

.welcomeBox__bf8 {
  padding: calc(var(--ring-unit) * 11) calc(var(--ring-unit) * 9) 0;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  contain: layout;

  /**
   * Source of colors
   * https://rescui.dev/design/colors/primary-tool/
   */
  --rs-color-primary-light-theme: #fc801d;
  --rs-color-primary-dim-light-theme: #fd994a;
  --rs-color-primary-fog-light-theme: #fee6d2;
  --rs-color-primary-t-dim-light-theme: rgba(252, 128, 29, 0.8);
  --rs-color-primary-t-fog-light-theme: rgba(252, 128, 29, 0.2);

  --rs-color-primary-dark-theme: #ff7936;
  --rs-color-primary-dim-dark-theme: #d16631;
  --rs-color-primary-fog-dark-theme: #472c21;
  --rs-color-primary-t-dim-dark-theme: rgba(255, 121, 54, 0.8);
  --rs-color-primary-t-fog-dark-theme: rgba(255, 121, 54, 0.2);
  --welcome-link-color: var(--rs-color-primary-light-theme);
}

.ring-ui-theme-dark .welcomeBody__c55 {
  --welcome-link-color: var(--rs-color-primary-dark-theme);
}

.welcomeBody__c55 {
  display: flex;
  justify-content: center;
}

.spring__bfd {
  flex: 1 1 auto;
  max-width: calc(var(--ring-unit) * 10);
  min-width: calc(var(--ring-unit) * 3);
}

.welcomeBodyColumn__ced {
  opacity: 0;
}

.welcomeBodyColumnVisible__dfd {
  opacity: 1;
  transform: translateY(-12px);
  transition: opacity ease 800ms, transform 800ms;
}

.dataColumn__f2f {
  padding-top: calc(var(--ring-unit) * 7);

  display: flex;
  flex-direction: column;

  gap: calc(var(--ring-unit) * 4);
  width: calc(var(--ring-unit) * 62);

  min-width: calc(var(--ring-unit) * 48.5);
}

.imageColumn__db8 {
  max-width: calc(var(--ring-unit) * 55);
}

.downloadToolboxApp__ae1 {
  margin-top: var(--ring-unit);
}

.companyNameIcon__c9f {
  max-height: calc(8 * var(--ring-unit));
}

.tbaLink__ccc {
  color: var(--welcome-link-color);
  padding: 0;
  cursor: pointer;
}

.tbaLink__ccc button {
  background-color: inherit;
  box-shadow: none;
  color: var(--welcome-link-color);
  font-size: 16px;
}

.tbaLink__ccc button:hover {
  box-shadow: none;
}

.infoContainer__b6a {
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 2);
}

.textContainer__d90 {
  width: 260px;
}

.backgroundWrapper__d56 {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}

.background__bba {
  position: absolute;
  top: -100px;
  right: -200px;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.toolboxAppImg__e1a {
  height: 550px;
}

.downloadToolboxAppContainer__ae5 {
  margin-top: calc(var(--ring-unit) * 2);
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 2);

  animation: fade-in__f12 1s ease;
}

@media (max-width: 900px) {
  .welcomeBody__c55 {
    gap: calc(var(--ring-unit) * 3);

    align-items: center;
    flex-direction: column;
    margin: auto;
  }

  .dataColumn__f2f {
    width: 100%;
    padding-top: 0;

    max-width: calc(var(--ring-unit) * 48.5);
  }

  .toolboxAppImg__e1a {
    max-height: 550px;
    height: auto;
    width: 100%;
  }

  .welcomeBox__bf8 {
    padding: calc(var(--ring-unit) * 3) var(--ring-unit);
  }

  .background__bba {
    top: 200px;
    right: 200px;
  }
}

@keyframes fade-in__f12 {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/welcome-page/unauthorized-welcome-page/unauthorized-welcome-page.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yDAAyD;EACzD,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;;EAEf;;;IAGE;EACF,uCAAuC;EACvC,2CAA2C;EAC3C,2CAA2C;EAC3C,6DAA6D;EAC7D,6DAA6D;;EAE7D,sCAAsC;EACtC,0CAA0C;EAC1C,0CAA0C;EAC1C,4DAA4D;EAC5D,4DAA4D;EAC5D,yDAAyD;AAC3D;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,uCAAuC;;EAEvC,aAAa;EACb,sBAAsB;;EAEtB,+BAA+B;EAC/B,kCAAkC;;EAElC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,+BAA+B;;EAE/B,+BAA0B;AAC5B;;AAEA;EACE;IACE,+BAA+B;;IAE/B,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;;IAEd,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@value breakpoint-middle from '~@jetbrains/ring-ui/components/global/global.css';\n\n.backgroundColor {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--ring-navigation-background-color);\n  z-index: -2;\n}\n\n.welcomeBox {\n  padding: calc(var(--ring-unit) * 11) calc(var(--ring-unit) * 9) 0;\n  width: 100%;\n  box-sizing: border-box;\n  position: relative;\n  contain: layout;\n\n  /**\n   * Source of colors\n   * https://rescui.dev/design/colors/primary-tool/\n   */\n  --rs-color-primary-light-theme: #fc801d;\n  --rs-color-primary-dim-light-theme: #fd994a;\n  --rs-color-primary-fog-light-theme: #fee6d2;\n  --rs-color-primary-t-dim-light-theme: rgba(252, 128, 29, 0.8);\n  --rs-color-primary-t-fog-light-theme: rgba(252, 128, 29, 0.2);\n\n  --rs-color-primary-dark-theme: #ff7936;\n  --rs-color-primary-dim-dark-theme: #d16631;\n  --rs-color-primary-fog-dark-theme: #472c21;\n  --rs-color-primary-t-dim-dark-theme: rgba(255, 121, 54, 0.8);\n  --rs-color-primary-t-fog-dark-theme: rgba(255, 121, 54, 0.2);\n  --welcome-link-color: var(--rs-color-primary-light-theme);\n}\n\n:global(.ring-ui-theme-dark) .welcomeBody {\n  --welcome-link-color: var(--rs-color-primary-dark-theme);\n}\n\n.welcomeBody {\n  display: flex;\n  justify-content: center;\n}\n\n.spring {\n  flex: 1 1 auto;\n  max-width: calc(var(--ring-unit) * 10);\n  min-width: calc(var(--ring-unit) * 3);\n}\n\n.welcomeBodyColumn {\n  opacity: 0;\n}\n\n.welcomeBodyColumnVisible {\n  opacity: 1;\n  transform: translateY(-12px);\n  transition: opacity ease 800ms, transform 800ms;\n}\n\n.dataColumn {\n  padding-top: calc(var(--ring-unit) * 7);\n\n  display: flex;\n  flex-direction: column;\n\n  gap: calc(var(--ring-unit) * 4);\n  width: calc(var(--ring-unit) * 62);\n\n  min-width: calc(var(--ring-unit) * 48.5);\n}\n\n.imageColumn {\n  max-width: calc(var(--ring-unit) * 55);\n}\n\n.downloadToolboxApp {\n  margin-top: var(--ring-unit);\n}\n\n.companyNameIcon {\n  max-height: calc(8 * var(--ring-unit));\n}\n\n.tbaLink {\n  color: var(--welcome-link-color);\n  padding: 0;\n  cursor: pointer;\n}\n\n.tbaLink button {\n  background-color: inherit;\n  box-shadow: none;\n  color: var(--welcome-link-color);\n  font-size: 16px;\n}\n\n.tbaLink button:hover {\n  box-shadow: none;\n}\n\n.infoContainer {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 2);\n}\n\n.textContainer {\n  width: 260px;\n}\n\n.backgroundWrapper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n}\n\n.background {\n  position: absolute;\n  top: -100px;\n  right: -200px;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.toolboxAppImg {\n  height: 550px;\n}\n\n.downloadToolboxAppContainer {\n  margin-top: calc(var(--ring-unit) * 2);\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 2);\n\n  animation: fade-in 1s ease;\n}\n\n@media (max-width: 900px) {\n  .welcomeBody {\n    gap: calc(var(--ring-unit) * 3);\n\n    align-items: center;\n    flex-direction: column;\n    margin: auto;\n  }\n\n  .dataColumn {\n    width: 100%;\n    padding-top: 0;\n\n    max-width: calc(var(--ring-unit) * 48.5);\n  }\n\n  .toolboxAppImg {\n    max-height: 550px;\n    height: auto;\n    width: 100%;\n  }\n\n  .welcomeBox {\n    padding: calc(var(--ring-unit) * 3) var(--ring-unit);\n  }\n\n  .background {\n    top: 200px;\n    right: 200px;\n  }\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  20% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoint-middle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["breakpoint-middle"]}`,
	"backgroundColor": `backgroundColor__db0`,
	"welcomeBox": `welcomeBox__bf8`,
	"welcomeBody": `welcomeBody__c55`,
	"spring": `spring__bfd`,
	"welcomeBodyColumn": `welcomeBodyColumn__ced`,
	"welcomeBodyColumnVisible": `welcomeBodyColumnVisible__dfd`,
	"dataColumn": `dataColumn__f2f`,
	"imageColumn": `imageColumn__db8`,
	"downloadToolboxApp": `downloadToolboxApp__ae1`,
	"companyNameIcon": `companyNameIcon__c9f`,
	"tbaLink": `tbaLink__ccc`,
	"infoContainer": `infoContainer__b6a`,
	"textContainer": `textContainer__d90`,
	"backgroundWrapper": `backgroundWrapper__d56`,
	"background": `background__bba`,
	"toolboxAppImg": `toolboxAppImg__e1a`,
	"downloadToolboxAppContainer": `downloadToolboxAppContainer__ae5`,
	"fade-in": `fade-in__f12`
};
export default ___CSS_LOADER_EXPORT___;
